module.exports = __webpack_public_path__ + "static/media/SnowballNFTEarlyVoter.90e403bb.gif";